import styled from "styled-components";


export const Ite = styled.div`
.itm-con{
    display: flex;
    justify-content: center;
}
img{
    max-width: 300px;
    max-height: 300px;
    border-radius: 5px;
}
.itm-con p{
    font-weight: 500;
}
.itm-con h5{
    text-align: center;
    color: #f00;
}
`